import { render, staticRenderFns } from "./LocalityShow.vue?vue&type=template&id=32a88a90&"
import script from "./LocalityShow.vue?vue&type=script&lang=js&"
export * from "./LocalityShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports